import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, Observable, tap, throwError } from 'rxjs';
import { CoreAuthConfigService } from '@features/auth/core-auth-config.service';
import { URI_APIs } from '@features/auth/const';
import { ErrorBase } from '@core/models/error.model';
import { ISsoAuthCodeResponse, ISsoService } from './sso.interface';
import { SsoErrorModel } from './sso-error.model';

@Injectable()
export class SsoService implements ISsoService {
  private readonly httpClient = inject(HttpClient);
  private readonly conf = inject(CoreAuthConfigService);

  requestAuthCode(redirectUri: string, state: string): Observable<ISsoAuthCodeResponse> {
    const url = this.conf.buildURL(URI_APIs.SSO_REQUEST_AUTH_CODE);
    const requestBody = {
      redirect_uri: redirectUri,
      state: state,
    };
    return this.httpClient
      .post<ISsoAuthCodeResponse>(url, requestBody, {
        // headers: {
        //   use_appkey: 'true',
        // },
      })
      .pipe(
        map((response) => response),
        tap((daga) => {
          console.log('SSO auth code response', daga);
        }),
        catchError((err: ErrorBase) => {
          return throwError(() => new SsoErrorModel().handle(err));
        })
      );
  }
}
